var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNickEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mage:edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2267 9.62764V12.5876C13.2265 13.0065 13.0601 13.4081 12.7639 13.7042C12.4678 14.0004 12.0662 14.1668 11.6473 14.167H3.91335C3.70518 14.1669 3.49909 14.1257 3.3069 14.0457C3.11472 13.9657 2.94023 13.8485 2.79347 13.7009C2.64671 13.5533 2.53057 13.3781 2.45172 13.1855C2.37287 12.9928 2.33287 12.7865 2.33401 12.5783V4.85298C2.33277 4.64514 2.3728 4.43913 2.45176 4.24687C2.53072 4.05462 2.64706 3.87995 2.79402 3.73299C2.94099 3.58602 3.11566 3.46969 3.30791 3.39072C3.50016 3.31176 3.70618 3.27174 3.91401 3.27298H6.87335",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.2266 5.99681L10.5033 3.27281M5.05664 10.5355V9.09214C5.05797 8.85414 5.15264 8.62547 5.31997 8.45681L11.6746 2.10214C11.759 2.01688 11.8594 1.94919 11.97 1.90299C12.0807 1.85679 12.1994 1.83301 12.3193 1.83301C12.4392 1.83301 12.5579 1.85679 12.6686 1.90299C12.7793 1.94919 12.8797 2.01688 12.964 2.10214L14.398 3.53614C14.4832 3.62046 14.5509 3.72085 14.5971 3.83151C14.6433 3.94217 14.6671 4.06089 14.6671 4.18081C14.6671 4.30072 14.6433 4.41944 14.5971 4.5301C14.5509 4.64076 14.4832 4.74115 14.398 4.82547L8.04331 11.1801C7.87433 11.348 7.64612 11.4425 7.40798 11.4435H5.96464C5.84535 11.4437 5.7272 11.4203 5.61696 11.3747C5.50671 11.3291 5.40655 11.2623 5.3222 11.1779C5.23785 11.0936 5.17097 10.9934 5.1254 10.8832C5.07983 10.7729 5.05647 10.6548 5.05664 10.5355Z",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNickEdit);
export default __webpack_public_path__ + "static/media/nick-edit.e9f3701099b4eaddb7f1a54ac681fd7f.svg";
export { ForwardRef as ReactComponent };